// extracted by mini-css-extract-plugin
export default {"container":"TableDateCell_container__FDZmr"};